// Ordre des ancres par route — DOIT correspondre à l'ordre des textes dans i18n tour.routes.<route>.
// null = bulle centrée (explication conceptuelle, sans surbrillance d'élément).
export const TOUR_ANCHORS = {
  "/": ["dash-header", "dash-kpi", "dash-task", null, null],
  "/agenda": ["agenda-header", "agenda-cal", "agenda-add", null, null],
  "/residents": ["res-header", "res-add", "res-search", null, null],
  "/statistiques": ["stats-header", "stats-kpi", "stats-export", null, null],
  "/familles": ["fam-header", "fam-add", "fam-list", null, null],
  "/prospects": ["prosp-header", "prosp-add", "prosp-kpi", null, null],
  "/rh": ["gm-header", "gm-add", "gm-toolbar", null, null],
  "/facturation": ["gm-header", "gm-add", "gm-toolbar", null, null],
  "/courriers": ["gm-header", "gm-add", "gm-toolbar", null, null],
  "/qualite": ["gm-header", "gm-add", "gm-toolbar", null, null],
  "/incontinence": [
    "inc-header", "inc-week", "inc-actions", "inc-kpis", "inc-floors", "inc-floors",
    "inc-table", "inc-table", "inc-recap", "inc-budget", null, null, null, null, null,
  ],
  "/formation": [
    "form-header", "form-year", "form-stats", "form-tabs", "form-add", "form-export",
    null, null, null, null,
  ],
  "/suivi-commercial": [
    "crm-header", "crm-kpi-occ", "crm-kpi-free", "crm-kpi-prosp", "crm-kpi-visits",
    "crm-kpi-adm", "crm-kpi-follow", "crm-tab-dashboard", "crm-tab-prospects", "crm-search",
    "crm-add-prospect", "crm-tab-visites", "crm-tab-relances", "crm-tab-admissions",
    "crm-tab-partenaires", "crm-tab-stats", "crm-tab-occupation", null, null, null,
  ],
  "/utilisateurs": ["users-header", "users-add", "users-maisons", "users-list", null],
  "/historique": ["audit-header", "audit-list", null],
};

export const TOUR_VERSION = "v2";
export const tourDoneKey = (route) => `cd_tour_${TOUR_VERSION}_${route}`;
export const TOUR_DISABLED_KEY = "cd_tour_disabled";
